export default __webpack_public_path__ + "static/media/Attendi-img.cd26c0ab.svg";